// seatViewFromView — adapt a redacted GameStateView into the SeatView[] the board renders. This is the
// single place that bridges the wire view shape to the render layer, so SeatBoard stays a pure render
// component that works identically for local and online play.
//
// Opponents expose only handCount in the view; SeatBoard draws their concealed hand FACE-DOWN by
// `hand.length`, so we fill a placeholder array of the right length (the tile ids are never shown — the
// face-down proxy ignores identity). The viewer's own concealed hand is rendered in the dock, not by
// SeatBoard, so its value here is unused but passed through for completeness.
import type { GameStateView, Seat, TileId } from '@mj/protocol';
import type { SeatView } from './SeatBoard';

const FACE_DOWN: TileId = 'z4'; // arbitrary back-filler; never rendered face-up (HandProxy is faceDown)

export function seatViewFromView(view: GameStateView, me: Seat, offlineSeat?: (s: Seat) => boolean): SeatView[] {
  return view.players.map((p) => ({
    seatWind: p.seatWind,
    score: p.score,
    hand: p.seat === me ? (p.hand ?? []) : Array.from({ length: p.handCount ?? 0 }, () => FACE_DOWN),
    melds: p.melds,
    discards: p.discards,
    // narrow to the board's riichi subset (avoid leaking `infinite: undefined` under exactOptionalPropertyTypes).
    riichi: p.riichi
      ? { declared: p.riichi.declared, open: p.riichi.open, ...(p.riichi.infinite !== undefined ? { infinite: p.riichi.infinite } : {}) }
      : null,
    kitaCount: p.kitaCount,
    // 花牌 is opt-in: only present in the view when nonempty (exactOptionalPropertyTypes → omit, never undefined).
    ...(p.flowers !== undefined ? { flowers: p.flowers } : {}),
    // online-only: seat is in the reconnect grace badge phase. Omit when no callback (solo/local).
    ...(offlineSeat !== undefined ? { offline: offlineSeat(p.seat) } : {}),
  }));
}
